// extracted by mini-css-extract-plugin
export var actions = "_mn-g";
export var benefitCard = "_mn-b";
export var benefitIcon = "_mn-d";
export var benefitLabel = "_mn-f";
export var benefits = "_mn-a";
export var benefitsSection = "_mn-8";
export var bodyText = "_mn-7";
export var closeButton = "_mn-2";
export var content = "_mn-3";
export var eyebrow = "_mn-4";
export var heading = "_mn-5";
export var image = "_mn-i";
export var imagePanel = "_mn-h";
export var modal = "_mn-0";
export var offerCard = "_mn-c";
export var offerIcon = "_mn-e";
export var sectionLabel = "_mn-9";
export var shell = "_mn-1";
export var title = "_mn-6";